export const getHasJWT = (): boolean => !!sessionStorage.getItem("auth_token");
export const getJWT = (): string | null => sessionStorage.getItem("auth_token");
export const setJWT = (authToken: string): void =>
  sessionStorage.setItem("auth_token", authToken);

// The refresh token is never stored here: the API keeps it in the HttpOnly
// jub-refresh-token cookie, out of reach of page scripts.

const getTokenUserId = (token: string | null): unknown => {
  try {
    const payload = token?.split(".")[1];
    if (!payload) return undefined;
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json).user_id;
  } catch {
    return undefined;
  }
};

// The refresh cookie is shared by every tab, so a refresh can hand back a token
// for whoever signed in last in another tab. True only when both tokens name a
// user and they differ.
export const isDifferentUser = (
  currentToken: string | null,
  nextToken: string
): boolean => {
  const current = getTokenUserId(currentToken);
  const next = getTokenUserId(nextToken);
  return current !== undefined && next !== undefined && current !== next;
};

// Where to go after logging in: the ?next= page the user was signed out of,
// if it is a path on this site, otherwise the fallback. The browser's own URL
// parser decides, because it strips tabs/newlines and reads "\" as "/", so
// "/\t/evil.example" is really "//evil.example" - another site. Only the
// parsed path is returned, never the raw value.
export const getPostLoginPath = (search: string, fallback: string): string => {
  const next = new URLSearchParams(search).get("next");
  if (!next || !next.startsWith("/")) return fallback;
  try {
    const url = new URL(next, window.location.origin);
    if (url.origin !== window.location.origin) return fallback;
    return url.pathname + url.search + url.hash;
  } catch {
    return fallback;
  }
};
